
import NoticeModularService from '../notice-modular-service';
import FormulaAssetsInfo from '@/components/formula-assets-info/formula-assets-info.vue';
export default {
  components: {
    FormulaAssetsInfo
  },
  data () {
    return {
      id: '', // 标的id
      projectInfo: {},
      notice_time: '', // 公告时间
      type: 0, // 判断是转让还是采购
      transaction: {}, // 流转详情
      bidInfo: { detail: [] },
      txt: '',
      year: '',
      code: '',
      citytitle: ''
    };
  },
  computed: {
    startTimeText () {
      const projectType = this.transaction.projectType;
      if (projectType === '2') {
        return '流转期限';
      }
      return '发包期限';
    },
    sumPlant () {
      let num = 0;
      this.bidInfo.detail.forEach(item => {
        // const obj = JSON.stringify(item.assetsInfo);
        if (item.forestList) {
          item.forestList.forEach(forestItem => {
            num += Number(forestItem.treeNumber);
          });
        }
      });
      return num;
    }
  },
  created () {
    this.id = this.$route.query.id;
    this.notice_time = this.$route.query.time;
    this.type = this.$route.query.type;
  },
  mounted () {
    if (Number(this.$route.query.type) === 1) {
      // 流转
      this.getAuctionResults();
    } else {
      // 集采
      this.getNoticeDetail();
    }
  },
  methods: {
    getNoticeDetail () {
      NoticeModularService.getTradingVerificationDetails(2, this.id, this.$route.query.userId).then(res => {
        if (res && res.code === '0') {
          this.projectInfo = res.data;
          this.txt = res.data.identificationCode.split('')[3];
          // this.year = res.data.identificationCode.split('')[0] + '+' +res.data.identificationCode.split('')[1];
          // this.code = res.data.identificationCode.split('').splice(2, 7).join('');
        }
      });
    },
    getAuctionResults () {
      NoticeModularService.getTradingVerificationDetails(1, this.id, this.$route.query.userId).then(res => {
        if (res && res.code === '0') {
          this.transaction = res.data;
          this.txt = res.data.identificationCode.split('')[3];
          // this.year = res.data.identificationCode.split('')[0] + res.data.identificationCode.split('')[1];
          // this.code = res.data.identificationCode.split('').splice(2, 7).join('');
          let arr = null;
          if (typeof res.data.projectAssets === 'string') {
            arr = JSON.parse(res.data.projectAssets);
          } else {
            arr = res.data.projectAssets;
          }
          // console.log(typeof res.data.projectAssets === 'string');
          this.bidInfo = {
            detail: arr
          };
        }
      });
    }
  }
};
